<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-card-text class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Instructor Health Card Form </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <br />
      <v-row dense>
        <v-col cols="12" sm="6" md="6">
          <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_health_card_data.inst_name"
            name="inst_name" label="Instructor Name"></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_health_card_data.inst_employee_id"
            name="inst_employee_id" label="Instructor Id"></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_health_card_data.gender" name="gender"
            label="Instructor Gender"></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6" md="3">
          <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_health_card_data.contact_no"
            name="contact_no" label="Contact No."></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_health_card_data.email" name="email"
            label="Email Id"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field rounded outlined color="#0F2027" flat dense
            v-model="inst_health_card_data.emergency_contact_number" name="emergency_contact_number"
            label="Emergency Contact No."></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_health_card_data.aadhar_no"
            name="aadhar_no" label="Aadhar No."></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6" md="3">
          <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_health_card_data.marital_status"
            name="marital_status" label="Marital Status"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_health_card_data.bloodgroup"
            name="bloodgroup" label="Blood Group"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_health_card_data.height" name="height"
            label="Height"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_health_card_data.weight" name="weight"
            label="Weight"></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6" md="6">
          <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_health_card_data.family_doctor_name"
            name="family_doctor_name" label="Family Doctor's name"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_health_card_data.family_doctor_number"
            name="family_doctor_number" label="Family Doctor's contact no."></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="4" md="4">
          <v-text-field rounded outlined color="#0F2027" flat dense
            v-model="inst_health_card_data.family_history_of_disease" name="family_history_of_disease"
            label="Family History of any disease"></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_health_card_data.allergy"
            name="allergy" label="Allergic to"></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field rounded outlined color="#0F2027" flat dense v-model="inst_health_card_data.medical_emergency"
            name="medical_emergency" label="Any major surgery/medical emergency during academic year"></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <v-col cols="12" sm="12" md="6">
          <v-textarea rows="3" clearable color="#0F2027" v-model="inst_health_card_data.address" name="address"
            auto-grow label="Residential Address" outlined></v-textarea>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn class="button" small @click="saveData()">Save</v-btn>
      </v-row>
    </v-card-text>
  </div>
</template>
<script>
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    inst_health_card_data: "",
    // extraBreadcrumbItems: [
    

    // ],
    // breadcrumbClass: "breadcrumb-style1",
  }),
  methods: {
    saveData() {
      //   alert("save data");
      const formData = {
        // instid: this.instid,
        instrData: this.inst_data,
      };
      console.log("in save fun", formData);
    },
  },
};
</script>
<style scoped>
</style>
